// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Customers from '../.components/provider/index.vue'
import NewCustomer from '../.components/provider/new.vue'
import Customer from '../.components/provider/show.vue'

import NewQuotePolicy from '../.components/provider/contracts/quote_policies/new.vue'
import QuotePolicy from '../.components/provider/contracts/quote_policies/show.vue'

import NewQuotation from '../.components/provider/contracts/quote_policies/quotations/new.vue'
import Quotation from '../.components/provider/contracts/quote_policies/quotations/show.vue'

import NewQuoteCondition from '../.components/provider/contracts/quote_policies/quote_conditions/new.vue'
import QuoteCondition from '../.components/provider/contracts/quote_policies/quote_conditions/show.vue'

import NewContract from '../.components/provider/contracts/new.vue'
import Contract from '../.components/provider/contracts/show.vue'

const customers_router = 'provider_customers';
const new_customer_router = 'new_provider_customer';
const customer_router = 'provider_customer';

const new_contract_router = 'new_provider_contract';
const contract_router = 'provider_contract';

const new_quote_policy_router = 'new_provider_quote_policy';
const quote_policy_router = 'provider_quote_policy';

const new_quote_condition_router = 'new_provider_quote_condition';
const quote_condition_router = 'provider_quote_condition';

const new_quotation_router = 'new_provider_quotation';
const quotation_router = 'provider_quotation';

const router = [
    {
        path: '/',
        component: Customers,
        name: 'provider_customers',
        meta: {
            api_name: "api_v1_provider_customers",
            breadcrumb: [customers_router],
            btns: [new_customer_router]
        }
    },
    {
        path: 'new',
        component: NewCustomer,
        name: 'new_provider_customer',
        meta: {
            api_name: "api_v1_provider_customers_create",
            breadcrumb: [customers_router, new_customer_router]
        }
    },
    {
        path: ':customer_identity',
        component: Customer,
        name: 'provider_customer',
        meta: {
            api_name: "api_v1_provider_customer",
            breadcrumb: [customers_router, customer_router]
        }
    },
    {
        path: ':customer_identity/contracts/new',
        component: NewContract,
        name: 'new_provider_contract',
        meta: {
            api_name: "api_v1_provider_contracts_create",
            breadcrumb: [customers_router, customer_router, new_contract_router]
        }
    },
    {
        path: ':customer_identity/contracts/:contract_identity',
        component: Contract,
        name: 'provider_contract',
        meta: {
            api_name: "api_v1_provider_contract_update",
            breadcrumb: [customers_router, customer_router, contract_router]
        }
    },
    {
        path: ':customer_identity/contracts/:contract_identity/quote_policies/:quote_policy_identity',
        component: QuotePolicy,
        name: 'provider_quote_policy',
        meta: {
            api_name: "api_v1_provider_quote_policy_update",
            breadcrumb: [customers_router, customer_router, contract_router, quote_policy_router]
        }
    },
    {
        path: ':customer_identity/contracts/:contract_identity/quote_policies/new',
        component: NewQuotePolicy,
        name: 'new_provider_quote_policy',
        meta: {
            api_name: "api_v1_provider_quote_policy_create",
            breadcrumb: [customers_router, customer_router, contract_router, new_quote_policy_router]
        }
    },
    {
        path: ':customer_identity/contracts/:contract_identity/quote_policies/:quote_policy_identity/quotations/new',
        component: NewQuotation,
        name: 'new_provider_quotation',
        meta: {
            api_name: "api_v1_provider_quotation_create",
            breadcrumb: [customers_router, customer_router, contract_router, quote_policy_router, new_quotation_router]
        }
    },
]


export default router;
